/**
 * It's a function that takes in an orderID and a token, and returns a response from the API.
 * @param orderID - the order ID
 * @param token - the token that I got from the login API
 * @returns {
 *     "status": "success",
 *     "data": {
 *         "order_id": "5e8f8f8f8f8f8f8f8f8f8f8f",
 *         "order_date": "2020-04-07T00:00:00.000Z",
 *         "order_status":
 */

export const getOrdersID = async (orderID, token) => {

    let headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    headers.append("Content-Type", "application/json");
    var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
    };
    const url = process.env.REACT_APP_ADMIN_API_URL + `/orders/dataOrderCustomer/` + orderID;
    const resp = await fetch(url, requestOptions);
    const response = await resp.json();
    return response;
}